import React, { useState, useEffect } from 'react';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1.jsx";
import { useLocation } from 'react-router-dom';
import { useLazyGetWarehouseByNameQuery } from '../../../../store/api/warehousemaster';
import Attachment from '../../../../utils/Attachment.jsx';

function ViewWarehouseDeatil({ warehouseData }) {
  const [tab, settab] = useState(1);
  const [res, setRes] = useState(false);
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error");
  const [showError, setShowError] = useState(false);

  //   new data
  const [DetailwarehouseData, setDetailWarehouseData] = useState(null);
  const [triggerGetWarehouse, { data, isLoading, errortwo }] = useLazyGetWarehouseByNameQuery();
  // console.log(data, "data_api");

  useEffect(() => {
    if (warehouseData?.name) {
      triggerGetWarehouse(warehouseData.name);
    }
  }, [warehouseData?.name]);

  useEffect(() => {
    if (data) {
      setDetailWarehouseData(data);
    }
  }, [data]);

  // end new data



  return (
    <>
      <FormLayoutTwo
        // title={DetailwarehouseData?.name || ''}
        title={'View Warehouse'}

        breadcrumbs={[
          { label: "Master" },
          { label: "Warehouse List", url: "/master/warehouse-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>


            {/* <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            /> */}
          </>
        }
      >
        <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                  <a className={tab === 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                    General Details{tab === 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>
              {/* <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                <span style={{ position: 'relative', top: '-1px' }}>
                  <GetIcon iconName="CgAttachment" size={12} />
                </span>
                <span className=" fw-semibold" style={{ color: "#391F84" }}>
                  Attachments
                </span>
              </div> */}
              <Attachment doctype="Warehouse"  docname={warehouseData.name}  />    
            </div>
          </div>


 <div className=" " style={{ background: '' }}>
          <div className="row">
            <div className="col-12">
              <div >
                <Tab1
                    DetailwarehouseData={DetailwarehouseData}

                  />
              </div>
            </div>
          </div>
        </div>

          
        </div>

        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayoutTwo>
    </>
  );
}

export default ViewWarehouseDeatil;
